import { createRootRoute, createRoute, LoaderFnContext, Outlet, redirect } from '@tanstack/react-router';
import { Layout } from '@/app/layout/layout.tsx';
import { useAuthStore } from '@/stores/auth.store.ts';
import { QueryClient } from '@tanstack/react-query';

export function Authenticate() {
  return (route: any) => {
    const authState = useAuthStore.getState();
    if (!authState.user) {
      throw redirect({
        to: '/login/$',
        search: {
          redirect: route.location.href,
        },
      });
    }
  };
}

export const rootRoute = createRootRoute({
  component: Outlet,
});

export const layoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'layout',
  path: '',
  component: Layout,
});

export type LoaderCtx = {
  context: {
    queryClient: typeof QueryClient;
  };
  location: {
    search: any;
  };
} & LoaderFnContext;

export const loaderFn = (cb: Function): any => {
  return async (ctx: LoaderFnContext) => {
    try {
      return await cb(ctx as LoaderCtx);
    } catch (error) {
      console.error('Loader Error:', error);
      throw error;
    }
  };
};
